import {Component, Input, Output, EventEmitter, HostListener, inject, ElementRef} from '@angular/core';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-color-picker',
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, TranslateModule],
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent {
    @Input() colors: string[] = [];
    @Input() selectedColor: string = '';

    @Output() colorChange = new EventEmitter<string>();

    private elementRef = inject(ElementRef);

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        if (!this.menuOpen) {
            return;
        }

        const clickedInside = this.elementRef.nativeElement.contains(event.target);

        if (!clickedInside) {
            this.menuOpen = false;
        }
    }

    menuOpen = false;

    toggleMenu() {
        this.menuOpen = !this.menuOpen;
        if (this.menuOpen) {
            setTimeout(() => {
                const focusedItem = document.querySelector('.color-picker__menu-option--selected')
                    || document.querySelector('.color-picker__menu-option');
                (focusedItem as HTMLElement)?.focus();
            }, 0);
        }
    }

    selectColor(color: string) {
        this.selectedColor = color;
        this.colorChange.emit(color);
        this.menuOpen = false;
        this.focusMenu();
    }

    isSelected(color: string) {
        return this.selectedColor === color;
    }

    handleMenuKey(event: KeyboardEvent, index: number) {
        const items = Array.from(
            document.querySelectorAll('.color-picker__menu-option')
        ) as HTMLElement[];

        const lastIndex = items.length - 1;
        let nextIndex = index;

        switch (event.key) {

            case 'Escape':
                event.preventDefault();
                this.menuOpen = false;
                this.focusMenu();
                return;

            case 'ArrowRight':
            case 'ArrowDown':
                event.preventDefault();
                nextIndex = (index + 1) % items.length;
                items[nextIndex].focus();
                return;

            case 'ArrowLeft':
            case 'ArrowUp':
                event.preventDefault();
                nextIndex = (index - 1 + items.length) % items.length;
                items[nextIndex].focus();
                return;

            case 'Tab':
                event.preventDefault();
                if (event.shiftKey) {
                    nextIndex = index === 0 ? lastIndex : index - 1;
                } else {
                    nextIndex = index === lastIndex ? 0 : index + 1;
                }
                items[nextIndex].focus();
                return;
        }

    }

    focusMenu(): void {
        setTimeout(() => {
            const trigger = document.getElementById('color-picker-control-color');
            trigger?.focus();
        }, 100);
    }
}
